import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import HeaderHome from '../components/Header/HeaderHome';
import useScript from '../hook/useScript';

const HomeLayout = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, [pathname]);
  useScript(
    "https://chat-plugin.pancake.vn/main/auto?page_id=web_Shotpik",
    "pancake-chat-script",
    {
      onLoad: () => console.log("Pancake chat script loaded successfully"),
      onError: (error) => console.error("Failed to load Pancake chat script:", error)
    }
  );
  return (
    <>
      <HeaderHome />
      <Outlet />
    </>
  );
};

export default HomeLayout;
